import type { PermissionData } from '../types'

export function computeEditPermission(permissionData: PermissionData) {
  if (permissionData.routesCount !== 1) return 'disabled'

  return 'enabled'
}
